import React, { useEffect, useState } from 'react';
import { Dialog } from "@mui/material";
import FireAlertsModal from './FireAlertsModal';
import Spinner from '../../../Spinner';
import shapeIcon from '../../../../assets/icons/shape-icon.png';
import axios from 'axios';
import { useUserContext } from '../../../../contexts/UserContext';
import { useFiresContext } from '../../../../contexts/FiresContext';
import { useAlertsContext } from '../../../../contexts/AlertsContext';
import FireTeamAlertsModal from '../../Teams/FireTeamAlertsModal';

export default function FiresModal(props) {
    const {
        getToken
    } = useUserContext();

    const {
        modal,
        setModal,
        fires,
        setFires,
        plotFires
    } = useFiresContext();

    const {
        getAlerts
    } = useAlertsContext();

    const {
        map,
        panel,
        setPanel
    } = props;

    const fire = modal.content ? modal.content : { };

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);

    const [addFireForm, setAddFireForm] = useState({
        fireName: fire.name,
        status: fire.active,
        cause: fire.cause,
        percontained: fire.perContained,
        type: fire.type,
    });

    const isBtnDisabled = () => {
        if ((addFireForm.fireName === fire.name) && (addFireForm.status === fire.active) && (addFireForm.cause === fire.cause) && (addFireForm.percontained === fire.perContained) && (addFireForm.type === fire.type)) {
            return true;
        } else {
            return false;
        }
    }

    const formatFireType = (type) => {
        switch (type) {
          case 'FI':
              return 'Fire Incident'
          case 'L':
              return 'Large Fire'
          case 'FM':
              return 'Fire Monitoring'
        }
    }

    const deleteFire = (fireId) => {
        setError(false);
        setLoading(true);
    
        getToken()
        .then((token) => {
          axios.delete(`https://firewatch-api.space-eyes.com/fires?fire_id=${fireId}`, {
              headers: {
                  'Authorization': `Bearer ${token}`
              }
          }).then((res) => {
            const fireToDelete = fires?.find((f) => f.fire_id === fireId);
            setFires(fires?.filter((f) => f.fire_id !== fireToDelete.fire_id));

            plotFires(map, fires?.filter((f) => f.fire_id !== fireToDelete.fire_id));

            if (panel.name === 'Fire PopUp') {
                setPanel({
                    name: 'Empty',
                    content: null
                })
            }

            setModal({
                type: false,
                content: null
            });

            getToken().then((token) => {
                getAlerts(token);
            }).catch((err) => console.log('error getting token', err));
          }).catch((err) => {
              console.log('error deleting fire: ', err.message);
              setLoading(false);
              setError('Trouble deleting fire. Please try again.');
          })
          }).catch((error) => {
              console.error('Failed to get token:', error);
              setLoading(false);
              setError('Trouble deleting fire. Please try again.');
          });
    }

    const updateFire = (fireId) => {
        setError(false);
        setLoading(true);

        if (addFireForm.fireName.length === 0 || addFireForm.status.length === 0) {
            setLoading(false);
            setError('Please fill out required fields.');
            return;
        }

        let activeStatus;
  
        if (addFireForm.status) {
            if (addFireForm.percontained === 100) {
                activeStatus = false;
            } else {
                activeStatus = true;
            }
        } else {
            if (!addFireForm.percontained) {
                activeStatus = false;
            } else if (addFireForm.percontained !== 100) {
                activeStatus = true;
            } else {
                activeStatus = false;
            }
        }
    
        getToken()
        .then((token) => {
          axios.put(`https://firewatch-api.space-eyes.com/fires`, {
            id: fireId,
            name: addFireForm.fireName,
            active: activeStatus,
            cause: addFireForm.cause,
            percontained: !activeStatus ? 100 : addFireForm.percontained,
            type: addFireForm.type
          },
          { 
            headers: {
              'Authorization': `Bearer ${token}`,
            }
          }
          ).then((res) => {
            setLoading(false);

            const otherFires = fires.filter((f) => f.fire_id !== res.data.fire.fire_id);

            setFires([res.data.fire, ...otherFires]);

            if (panel.name === 'Fire PopUp') {
                setPanel({
                    ...panel,
                    content: res.data.fire
                })
            }

            setModal({
                type: false,
                content: null
            });
          }).catch((err) => {
              console.log('error updating fire: ', err.message);
              setLoading(false);
              setError('Trouble updating fire. Please try again.');
          })
          }).catch((error) => {
              console.error('Failed to get token:', error);
              setLoading(false);
              setError('Trouble updating fire. Please try again.');
          });
    }

    const stageSwitch = (stage) => {
        switch (stage) {
            case 'edit-and-delete':
                return (
                    <div className='fires-modal'>
                        <div className='fires-modal-title'>Updating Fire</div>
                        <div className='fires-modal-content'>
                            <div className='add-fire-content-form'>
                                <div className='add-fire-content-form-input-container'>
                                    <div className='add-fire-content-form-input-container-title'>Fire Name - Required</div>
                                    <input 
                                        type='text'
                                        value={addFireForm.fireName}
                                        placeholder='Example: West Park Fire'
                                        className='add-fire-content-form-input-container-input'
                                        onChange={(e) => setAddFireForm((prevState) => ({ ...prevState, fireName: e.target.value }))}
                                    />
                                </div>
                                <div className='add-fire-content-form-input-container'>
                                    <div className='add-fire-content-form-input-container-title'>Status - Required</div>
                                    <select
                                        className='add-fire-content-form-input-container-select'
                                        value={addFireForm.status}
                                        onChange={(e) => setAddFireForm((prevState) => ({ ...prevState, status: e.target.value }))}
                                        aria-label="add-fire"
                                    >
                                    <option value="" disabled>Select an option</option>
                                    <option value={true}>Active</option>
                                    <option value={false}>Contained</option>
                                    </select>
                                </div>
                                <div className='add-fire-content-form-input-container'>
                                    <div className='add-fire-content-form-input-container-title'>Cause - Optional</div>
                                    <select
                                        className='add-fire-content-form-input-container-select'
                                        value={addFireForm.cause || ""}
                                        onChange={(e) => setAddFireForm((prevState) => ({ ...prevState, cause: e.target.value }))}
                                        aria-label="add-fire"
                                    >
                                    <option value="" disabled>Select an option</option>
                                    <option value="NATURAL">NATURAL</option>
                                    <option value="HUMAN">HUMAN</option>
                                    <option value="UNDETERMINED">UNDETERMINED</option>
                                    </select>
                                </div>
                                <div className='add-fire-content-form-input-container'>
                                    <div className='add-fire-content-form-input-container-title'>Type - Optional</div>
                                    <select
                                        className='add-fire-content-form-input-container-select'
                                        value={addFireForm.type || ""}
                                        onChange={(e) => setAddFireForm((prevState) => ({ ...prevState, type: e.target.value }))}
                                        aria-label="add-fire"
                                    >
                                    <option value="" disabled>Select an option</option>
                                    <option value="FI">{formatFireType('FI')}</option>
                                    <option value="L">{formatFireType('L')}</option>
                                    <option value="FM">{formatFireType('FM')}</option>
                                    </select>
                                </div>
                                <div className='add-fire-content-form-input-container'>
                                    <div className='add-fire-content-form-input-container-title'>Containment % - Optional</div>
                                    <div className='add-fire-content-form-input-container-slider-container'>
                                    <input
                                        className='add-fire-content-form-input-container-slider-container-slider'
                                        color='orange'
                                        type="range" 
                                        min="0" 
                                        max="100" 
                                        step="10"
                                        value={addFireForm.percontained ? addFireForm.percontained : 0} 
                                        onChange={(e) => setAddFireForm((prevState) => ({ ...prevState, percontained: e.target.value }))}
                                    />
                                    <div className='add-fire-content-form-input-container-slider-container-text'>{addFireForm.percontained !== null ? `${addFireForm.percontained}%` : 'N/A'}</div>
                                    </div>
                                </div>
                                {/* <div className='add-fire-content-form-update-perimeter'>
                                    Update Perimeter
                                    <img src={shapeIcon} className='add-fire-content-form-update-perimeter-icon'/>
                                </div> */}
                            </div>
                        </div>
                       {error && <div className='fires-modal-content-error'>{error}</div>}
                       {loading ?
                       <div style={{ paddingTop: '1rem' }}>
                         <Spinner />
                       </div>
                       :
                       <div className='fires-modal-bottom-btns'>
                            <div 
                                className='fires-modal-bottom-btns-btn-cancel'
                                onClick={() => {
                                    setModal({
                                        type: false,
                                        content: null
                                    })
                                }}>
                                Cancel
                            </div>
                            <button 
                                className='fires-modal-bottom-btns-btn-save'
                                disabled={isBtnDisabled()}
                                style={isBtnDisabled() ? { cursor: 'not-allowed', background: 'gray' } :  { } }
                                onClick={() => updateFire(fire.fire_id)}
                                >
                                Save Changes
                            </button>
                        </div>}
                        <div 
                            className='fires-modal-delete-btn'
                            onClick={() => {
                                setError(false);
                                
                                setModal({
                                    type: 'delete-confirmation',
                                    content: fire 
                                })
                            }}
                            >
                            DELETE FIRE
                        </div>
                    </div>
                )
            case 'alerts':
                return (
                   <FireAlertsModal
                        modal={modal}
                        setModal={setModal}
                   />
                )
            case 'team-alerts':
                return (
                    <FireTeamAlertsModal
                        modal={modal}
                        setModal={setModal}
                    />
                )
            case 'delete-confirmation':
                return (
                    <div className='fires-modal'>
                        <div className='fires-modal-title'>Deleting Fire</div>
                        <div className='fires-modal-content'>
                            <div className='fires-modal-content-text'>Are you sure you want to delete this fire?</div>
                        </div>
                        {error && <div className='fires-modal-content-error'>{error}</div>}
                       {loading ?
                       <div style={{ paddingTop: '1rem' }}>
                        <Spinner />
                       </div>
                       :
                       <div className='fires-modal-bottom-btns'>
                            <div 
                                className='fires-modal-bottom-btns-btn-save'
                                onClick={() => {
                                    setModal({
                                        type: false,
                                        content: null
                                    })
                                }}>
                                Cancel
                            </div>
                            <div 
                                className='fires-modal-bottom-btns-btn-cancel'
                                onClick={() => deleteFire(fire.fire_id)}
                            >
                                Yes
                            </div>
                        </div>}
                    </div>
                )
        }
    }

    return (
        <Dialog
            open={modal.type}
            onClose={() => {
                if (modal.type) {
                    setModal({
                        type: false,
                        content: null
                    })
                }
            }}
            PaperProps={{
                sx: {
                  backgroundColor: "white",
                }
              }}
        >
            {stageSwitch(modal.type)}
        </Dialog>
    )
}